import "./IconWarningCircle.scss";

export const IconWarningCircle = () => {
  return <span className="icon-warning-circle"></span>;
};
